import type { OnInit } from '@angular/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { NotificationInterface } from '../../models/notification.interface';
import { NotificationLevelEnum } from '../../models/notification.interface';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  @Input() notification: NotificationInterface;
  @Output() notificationClosed = new EventEmitter<number>();
  NotificationLevelEnum = NotificationLevelEnum;

  constructor(private readonly translateService: TranslateService) {}

  ngOnInit(): void {
    this.setTrad();
  }

  closeNotification(notificationId: number) {
    this.notificationClosed.emit(notificationId);
  }

  isToday(date: Date) {
    const newDate = new Date(date);
    const today = new Date();
    return newDate.getDate() === today.getDate() &&
      newDate.getMonth() === today.getMonth() &&
      newDate.getFullYear() === today.getFullYear();
  }

  getPatientName() {
    const params = this.notification.param.split(',');
    return params[0].length === 0 ? params[1] : params[0] + ' - ' + params[1];
  }

  getInfoShareStudy() {
    const params = this.notification.param.split(',');
    return (params[0] !== '' ? params[0] + ' - ' : '') + params[1] + ' (' + params[2] + ')';
  }

  getInfoShareAlbum() {
    const params = this.notification.param.split(',');
    return `${params[0]} - ${this.translateService.instant(`enum.album_type.${params[1].toLowerCase()}`) as string} (${params[2]})`;
  }

  getTextMessage(): string {
    const params = this.notification.param.split(',');
    const message = 'mainNav.notificationsMenu.' + (this.notification.code.toLowerCase() + '.' + params[0]).toLowerCase();
    if (params.length > 1) {
      const args: Record<string, string> = {};
      const idx = 0;
      params.slice(1).forEach(p => {
        args[`arg${idx}`] = p;
      });
      return this.translateService.instant(message, args) as string;
    } else {
      return this.translateService.instant(message) as string;
    }
  }


  private setTrad() {
    marker('mainNav.notificationsMenu.new_study');
    marker('mainNav.notificationsMenu.welcome');
    marker('mainNav.notificationsMenu.message');
    marker('mainNav.notificationsMenu.share_study');
    marker('mainNav.notificationsMenu.share_album');
    marker('mainNav.notificationsMenu.text');
    marker('mainNav.notificationsMenu.info');
    marker('mainNav.notificationsMenu.success');
    marker('mainNav.notificationsMenu.error');
    marker('mainNav.notificationsMenu.warning');
    marker('mainNav.notificationsMenu.scc_study_start_review');
    marker('mainNav.notificationsMenu.scc_study_need_review');
    marker('mainNav.notificationsMenu.scc_study_new_review');
  }
}
